/* @flow */
import * as React from "react";
import Media from "react-media";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { ModalConsumer } from "../components/common/ModalProvider";
import Private from "../components/Private";
import TradingPlatform from "../components/TradingPlatform";
import { TradeThemeProvider } from "../components/ThemeProvider";
import FreeBonusPopup from "../components/FreeBonusPopup";
import MobileLayout from "../components/Trade/Mobile";
import DesktopLayout from "../components/Trade/Desktop";
import { withDeposit } from "../components/common/withDeposit";
import { useBonusTimerApi } from "../components/hooks/useBonusTimer";
import { SocialTradingContext } from "../components/SocialTrading/ToggleSocial";
import ABTest from "../components/ABTest";
import ProfitableTerms from "../components/TradeModals/ProfitableTerms";

type Props = {
  stock: string | null
};

const TourRotator = props => {
  const showTour =
    (!props.tourRefBonus &&
      props.tourShownForUser !== 1 &&
      !props.tourGetReal &&
      !sessionStorage.getItem("showTourLater") &&
      props.showDeposit) ||
    (parseFloat(props.tourGetFundsAvailableReal) > 0 &&
      props.tourRegScenario === "full_real" &&
      props.showDeposit);

  return showTour ? <Redirect push to="/sightseeing" /> : null;
};

function Platform(props: Props) {
  const { stock } = props;
  const [showSocialTrading, toggleSocialTrading] = React.useState(false);
  const [showBonusPopup, toggleBonusPopup] = React.useState(false);
  const bonus = useBonusTimerApi({ time: props.time });

  const bonusAvailable =
    bonus != null && bonus.duration > 0 && bonus.status === "available";

  React.useEffect(() => {
    const shownKey = `${props.userId}:bonusPopup`;

    try {
      const alreadyShown = localStorage.getItem(shownKey);
      if (
        bonusAvailable &&
        !JSON.parse(alreadyShown)
      ) {
        toggleBonusPopup(true);
      }
    } catch (e) {}
  }, [props.userId, toggleBonusPopup, bonusAvailable]);

  return (
    <SocialTradingContext.Provider
      value={[showSocialTrading, toggleSocialTrading]}
    >
      <TradeThemeProvider>
        <React.Fragment>
          <ABTest campaign="80_percent_user">
            {showBonusPopup && (
              <FreeBonusPopup
                promo={bonus && bonus.promo}
                onClose={() => {
                  toggleBonusPopup(false);
                  try {
                    localStorage.setItem(
                      `${props.userId}:bonusPopup`,
                      JSON.stringify(true)
                    );
                  } catch (e) {}
                }}
              />
            )}
          </ABTest>
          <ProfitableTerms />
          <TourRotator {...props} />
          <Media query="(max-width: 959px)">
            {matches => (
              <ModalConsumer>
                {({ showModal, hideModal }) => (
                  <TradingPlatform
                    userId={props.userId}
                    dispatch={props.dispatch}
                    layout={matches ? MobileLayout : DesktopLayout}
                    stock={(stock || "").toUpperCase()}
                    showModal={showModal}
                    hideModal={hideModal}
                  />
                )}
              </ModalConsumer>
            )}
          </Media>
        </React.Fragment>
      </TradeThemeProvider>
    </SocialTradingContext.Provider>
  );
}

function mapStateToProps(state: State) {
  if (state.serverData == null) {
    throw new TypeError(
      "Rare race condition when profile appears eariler than serverData"
    );
  }

  return {
    time: state.time || Date.now(),
    userId: state.profile && state.profile.id,
    tourGetFundsAvailableReal: state.serverData.tourGetFundsAvailableReal,
    tourGetReal: state.serverData.tourGetReal,
    tourRefBonus: state.serverData.tourRefBonus,
    tourRegScenario: state.serverData.tourRegScenario,
    tourShownForUser: state.profile && state.profile.tour_shown
  };
}

export default Private(withDeposit(connect(mapStateToProps)(Platform)));



// WEBPACK FOOTER //
// ./src/pages/trade.js